import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label, Form, FormGroup
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, Language} from "App/constants";
import {basketExtendedWarrantySelectionChange} from "App/basket";
import {
    CurrentConfigurationExtendedwarranty,
    ConfiguratorProductExtendedwarrantyWarrantytypes, ConfiguratorProductExtendedwarranty
} from "App/services/api";
import {selectedLang} from "App/helper";


interface StateToProps extends CurrencyProps {
    extendedWarrantyDef: ConfiguratorProductExtendedwarranty;
    extendedWarranty: CurrentConfigurationExtendedwarranty | undefined;
}

interface DispatchToProps {
    onSelectWarranty: (selected: boolean, ewDuration: number|undefined, ewType: string|undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSelectWarranty: (selected: boolean, duration: number|undefined, type: string|undefined) => dispatch(basketExtendedWarrantySelectionChange(selected, duration, type))
});

interface ComponentState {
    isVisible: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: !!props.extendedWarranty
    }
}

function buildMap (extendedWarrantyDef: ConfiguratorProductExtendedwarranty, invalid: Array<object>): Map<number, Array<ConfiguratorProductExtendedwarrantyWarrantytypes>> {
    return extendedWarrantyDef.durationmonths.reduce((pv, cv) => {

        const invalidWT: Array<string> = invalid.filter((value) => Object.values(value)[0]==cv).map(value => Object.keys(value)[0]);
        const validWT: Array<ConfiguratorProductExtendedwarrantyWarrantytypes> = extendedWarrantyDef.warrantytypes.slice(0).filter(value => value.key&&invalidWT.indexOf(value.key)<0);
        return validWT.length>0?pv.set(cv, validWT):pv;
//        const invalidMonts: Array<number> = invalid.filter(value => Object.keys(value)[0]==cv).map(value => Object.values(value)[0]);
//        const durationMonths: Array<number> = extendedWarrantyDef.durationmonths.slice(0).filter(value => invalidMonts.indexOf(value)>=0);
//        return durationMonths.length>0?pv.set(cv, durationMonths):pv;
    }, new Map<number, Array<ConfiguratorProductExtendedwarrantyWarrantytypes>>());
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
        this.selectWarranty = this.selectWarranty.bind(this);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    selectWarranty(map: Map<number, Array<ConfiguratorProductExtendedwarrantyWarrantytypes>>, duration: number|undefined, type: string|undefined) {
        const {extendedWarranty, onSelectWarranty} = this.props;
        if (duration) {
            const availableTypes: Array<ConfiguratorProductExtendedwarrantyWarrantytypes> | undefined = map.get(duration);
            const currentType: ConfiguratorProductExtendedwarrantyWarrantytypes | undefined = availableTypes&&extendedWarranty&&availableTypes.find( x => x.key===extendedWarranty.warrantytype);
            onSelectWarranty( true, duration, currentType&&currentType.key||(availableTypes&&availableTypes[0].key));
        }
        if (type) {
            const availableDurations: Array<number> | undefined = [...map.keys()].filter(value => (map.get(value)||[]).find(wt => wt.key===type));
            const currentDuration: number | undefined = availableDurations&&extendedWarranty&&availableDurations.find(value => value===extendedWarranty.durationmonths);
            onSelectWarranty( true, currentDuration||(availableDurations&&availableDurations[0]), type );
        }
    }

    render() {
        const {t, i18n, onSelectWarranty, extendedWarranty, extendedWarrantyDef} = this.props;
        const language: Language = selectedLang(i18n);
        const invalid: Array<object> = extendedWarrantyDef.invalid.filter(value => (!!value));
        const map: Map<number, Array<ConfiguratorProductExtendedwarrantyWarrantytypes>> = buildMap(extendedWarrantyDef, invalid);
        const ewDuration: number = extendedWarranty&&extendedWarranty.durationmonths||Number([...map.keys()][0]);
        const selectedTypes: Array<ConfiguratorProductExtendedwarrantyWarrantytypes> | undefined = map.get(ewDuration);
        const ewType: string | undefined = extendedWarranty&&extendedWarranty.warrantytype||(selectedTypes&&selectedTypes[0].key);
        return <React.Fragment>
            <CardHeader className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                <span className="m-0 w-75 float-left title-normal-uppercase">{ t('products.configuration.extendedwarranty')}</span>
                <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible? 'fa-chevron-up' : 'fa-chevron-down')}></i>
            </CardHeader>
            <Collapse isOpen={this.state.isVisible}>
                <CardBody className="px-5 pt-2 pb-3 bodyslice">
                    <Row className="no-gutters">
                        <Col className="align-items-center py-2 pr-0 col-sm-8">
                            <div className="form-check">
                                <Input type="checkbox" checked={!!extendedWarranty}
                                       id={"optionInputExtendedWarranty"} name={"optionInputExtendedWarranty"}
                                       className="align-middle"
                                       onChange={(e) => onSelectWarranty(e.target.checked, ewDuration, ewType)}/>
                                <Label htmlFor={"optionInputExtendedWarranty"}
                                       className="py-0 text-normal-details light align-middle">{t('products.configuration.includeextendedwarranty')}</Label>
                            </div>
                        </Col>
                        <Col className="align-items-center py-2 pl-0 col-sm-4 text-right">
                        </Col>
                    </Row>
                    <Row className="no-gutters">
                        <Col className="align-items-center pr-0 col-sm-4">
                            <Form inline>
                                <FormGroup>
                                    <Label for="ewDuration"
                                           className={"text-normal-details light pl-5"}>{t('products.configuration.extendedwarrantyduration')}</Label>
                                    <Input type="select" name="ewDuration" id="ewDuration"
                                           disabled={!extendedWarranty}
                                           className={"text-select-details light ml-3"}
                                           value={ewDuration}
                                           onChange={(e) => this.selectWarranty(map, Number(e.target.value), undefined)}>
                                        {
                                            [...map.keys()].map((month: number) => (
                                                <option key={month}
                                                        value={month}>{t('products.configuration.extendedwarrantymonth', {month: month})}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col className="align-items-center pl-0 col-sm-8">
                            <Form inline>
                                <FormGroup>
                                    <Label for="ewType"
                                           className={"text-normal-details light pl-5"}>{t('products.configuration.extendedwarrantytype')}</Label>
                                    <Input type="select" name="ewType" id="ewType" disabled={!extendedWarranty}
                                           className={"text-select-details light ml-3"}
                                           value={ewType}
                                           onChange={(e) => this.selectWarranty(map, undefined, e.target.value)}>
                                        {
                                            selectedTypes&&selectedTypes
                                            .map((warrantytype: ConfiguratorProductExtendedwarrantyWarrantytypes, index: number) => (
                                                <option key={warrantytype.key}
                                                        value={warrantytype.key}>{warrantytype[language]}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </React.Fragment>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/ExtendedWarranty.tsx